import { createContext, useContext } from "react";
import { AppSidePanelState } from "../types/AppSidePanelState";
import { ContextProviderProps } from "../../../types/ContextProviderProps";
import { usePortfolioItemsService } from "../../../hooks/use-portfolio-service/usePortfolioItemsService";

const AppSidePanelContext = createContext<AppSidePanelState | undefined>(undefined);

export function AppSidePanelContextProvider({ children }: ContextProviderProps) {
    const {
        marketDataDto,
        portfolios,
        selectedPortfolio,
        createPortfolio,
        portfolioProfile,
        comparedPortfolioProfile,
        setSelectedPortfolioByName,
        editSelectedPortfolio,
        saveSelectedPortfolio,
        deleteSelectedPortfolio,
        addOptionToPortfolio,
        addFutureToPortfolio,
        updateSelectedPortfolio,
        fetchSelectedPortfolio,
        updateItemInSelectedPortfolio,
        deleteItemFromSelectedPortfolio,
        refreshPortfolioProfile,
        selectedComparedPortfolio,
        setSelectedComparedPortfolioByName,
        cloneSelectedPortfolio,
        selectedPortfolioDates,
        updatePositionInSelectedPortfolio,
        saveCustomImpliedVolatility,
        saveAutoOrderConfiguration,
        fetchAutoOrderConfiguration,
        resetAutoOrderConfigurationState,
    } = usePortfolioItemsService();
    
    const value = {
        marketDataDto,
        portfolios,
        selectedPortfolio,
        portfolioProfile,
        comparedPortfolioProfile,
        setSelectedPortfolioByName,
        addOptionToPortfolio,
        addFutureToPortfolio,
        updateSelectedPortfolio,
        fetchSelectedPortfolio,
        updateItemInSelectedPortfolio,
        deleteItemFromSelectedPortfolio,
        createPortfolio,
        editSelectedPortfolio,
        saveSelectedPortfolio,
        deleteSelectedPortfolio,
        refreshPortfolioProfile,
        selectedComparedPortfolio,
        setSelectedComparedPortfolioByName,
        cloneSelectedPortfolio,
        selectedPortfolioDates,
        updatePositionInSelectedPortfolio,
        saveCustomImpliedVolatility,
        saveAutoOrderConfiguration,
        fetchAutoOrderConfiguration,
        resetAutoOrderConfigurationState,
    };
    
    return (
        <AppSidePanelContext.Provider
            value={value}
        >
            {children}
        </AppSidePanelContext.Provider>        
    );
}

export const useAppSidePanelContextProvider = () => {
    const context = useContext(AppSidePanelContext);
    
    if (!context) {
        throw new Error('useAppSidePanelContextProvider is undefined!');
    }
    
    return context;
}
